import { CSSProperties } from "react";

export const XArrowSvg = ({
  size,
  style,
  layout = "horizontal",
}: {
  size: number;
  style?: CSSProperties;
  layout?: "horizontal" | "vertical";
}) => {
  const isHorizontal = layout === "horizontal";
  const width = isHorizontal ? size : (size * 96) / 61;
  const height = (width / 61) * 96;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 61 96"
      style={{
        transform: `rotate(${isHorizontal ? 0 : 90}deg)`,
        ...style,
      }}
    >
      <path d="M22 1H1V95H22L60 48.5L22 1Z" fill="#e3e3e3" stroke="#AB7334" />
    </svg>
  );
};
